import { Grid } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionNOTESFields } from '../types/fields';
import { OperacionNOTES } from "../types/types";

type SeccionNOTESDatosOperacionProps = {
  operacion?: OperacionNOTES;
}

const SeccionNOTESDatosOperacion = ({ operacion }: SeccionNOTESDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      {operacion && (
        <SectionBox>
          <Grid item xs={12} md={3}>
            <FieldView label='País' value={operacion[OperacionNOTESFields.NombrePais]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView
              label='Usuario Alta'
              value={`${operacion[OperacionNOTESFields.NombreUsuarioAlta]} ${operacion[OperacionNOTESFields.ApellidoUsuarioAlta]}`}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Unidad Negocio' value={operacion[OperacionNOTESFields.UnidadNegocio]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Equipo Comercial' value={operacion[OperacionNOTESFields.SectorComercial]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView label='Fecha Solicitud' value={dateFormatter.toShortDate(operacion[OperacionNOTESFields.FechaAprobacion])} />
          </Grid>
          <Grid item xs={12} md={3}>
            <FieldView
              label='Fecha Vencimiento'
              value={operacion[OperacionNOTESFields.FechaVencimiento]
                ? dateFormatter.toShortDate(operacion[OperacionNOTESFields.FechaVencimiento])
                : undefined}
            />
          </Grid>
        </SectionBox>
      )}
    </CardActions>
  );
}

export default SeccionNOTESDatosOperacion;
